import uikitvariables from "Styles/UIKit/uikit-breakpoints.module.scss";

export type MediaBreakpointDirection = "up" | "down";
export type MediaBreakpoint = keyof typeof uikitvariables;

export function getBreakpointWidth (direction: MediaBreakpointDirection, breakpoint: MediaBreakpoint): number {
   if(direction == "up")
      return parseFloat(uikitvariables[breakpoint]);
   //This logic comes from bootstrap4 mixins/_breakpoints.scss   
   const originalBreakpointWidth = parseFloat(uikitvariables[breakpoint]);
   let nextBreakpointWidth = 0;
   for(const cBreakpoint in uikitvariables) {
      const currentBreakpointWidth = parseFloat(uikitvariables[cBreakpoint]);
      if(currentBreakpointWidth > originalBreakpointWidth) {
         if(!nextBreakpointWidth)
            nextBreakpointWidth = currentBreakpointWidth;
         else if(currentBreakpointWidth < nextBreakpointWidth)
            nextBreakpointWidth = currentBreakpointWidth;
      }
   }
   // Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.
   // See https://bugs.webkit.org/show_bug.cgi?id=178261
   return nextBreakpointWidth - 0.02;
}